import { render, staticRenderFns } from "./Base400Black.vue?vue&type=template&id=90fc63ee&scoped=true&"
var script = {}
import style0 from "./Base400Black.vue?vue&type=style&index=0&id=90fc63ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fc63ee",
  null
  
)

export default component.exports